// Device type to title mapping
export const DEVICE_TITLES = {
  'reverse-osmosis': 'Reverse Osmosis Health Check',
  'water-filter': 'Water Filter Health Check',
  'water-softener': 'Water Softener Health Check',
  softener: 'Water Softener Health Check',
};

// Check items by device type (RO has 8 per design)
export const RO_CHECK_ITEMS = [
  { key: 'inlet-pressure', label: 'Inlet Pressure', hasInfo: true },
  { key: 'tank-pressure-detection', label: 'Tank Pressure Detection', hasInfo: false },
  { key: 'system-pressure-detection', label: 'System Pressure Detection', hasInfo: false },
  { key: 'device-connection-status', label: 'Device Connection Status', hasInfo: false },
  { key: 'ro-feed-flow-detection', label: 'RO Feed Flow Detection', hasInfo: false },
  { key: 'permeate-production-check', label: 'Permeate Production Check', hasInfo: false },
  {
    key: 'inlet-product-bypass-flow-detection',
    label: 'Inlet-Product Bypass Flow Detection',
    hasInfo: false,
  },
  {
    key: 'inlet-product-flow-verification',
    label: 'Inlet-Product Flow Verification',
    hasInfo: false,
  },
];

export const WF_CHECK_ITEMS = [
  { key: 'inlet-pressure-test', label: 'Inlet pressure test', hasInfo: false },
  { key: 'outlet-pressure-test', label: 'Outlet pressure test', hasInfo: false },
  { key: 'device-connection-status', label: 'Device Connection Status', hasInfo: false },
  { key: 'normal-flow-operation', label: 'Normal Flow Operation', hasInfo: false },
  {
    key: 'bypass-during-normal-flow-check',
    label: 'Bypass During Normal Flow Check',
    hasInfo: false,
  },
  /** Legacy key stored on older health check reports */
  { key: 'bypass-flow-detection', label: 'Bypass Flow Detection', hasInfo: false },
  /** Legacy key stored on older health check reports */
  { key: 'pressure-sensor-activity', label: 'Pressure Sensor Activity', hasInfo: false },
];

export const SOFTENER_CHECK_ITEMS = [
  { key: 'brine-level-detection', label: 'Brine Level Detection', hasInfo: false },
  { key: 'device-connection-status', label: 'Device Connection Status', hasInfo: false },
];

export const CHECK_ITEMS_BY_DEVICE = {
  'reverse-osmosis': RO_CHECK_ITEMS,
  'water-filter': WF_CHECK_ITEMS,
  'water-softener': SOFTENER_CHECK_ITEMS,
};

/** Map check_key (API) -> label for expanded check list */
export const CHECK_KEY_LABELS = [
  ...RO_CHECK_ITEMS,
  ...WF_CHECK_ITEMS,
  ...SOFTENER_CHECK_ITEMS,
].reduce((acc, { key, label }) => {
  if (key && !acc[key]) acc[key] = label;
  return acc;
}, {});

export const STATE_STYLES = {
  Pass: { bg: '#DFF5E5', color: '#09AA36' },
  Failed: { bg: '#FBC7C7', color: '#C80000' },
  Skipped: { bg: '#E8E8E8', color: '#808285' },
};

// execution_source to UI label mapping (API values: install, manual; legacy: mobile, web, cron)
export const EXECUTION_SOURCE_LABELS = {
  install: 'Install',
  manual: 'Manual',
  mobile: 'Install',
  web: 'Dashboard',
  cron: 'Scheduled',
};

export function formatTriggeredBy(triggeredBy) {
  if (!triggeredBy) return '—';
  const name = [triggeredBy.first_name, triggeredBy.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();
  if (name && triggeredBy.email) return `${name} (${triggeredBy.email})`;
  if (name) return name;
  if (triggeredBy.email) return triggeredBy.email;
  return '—';
}

// Mock: health check attempts for detail view (fallback)
export const MOCK_ATTEMPTS = [
  {
    id: 1,
    state: 'Pass',
    mode: 'Install',
    triggeredBy: 'Installer name',
    timestamp: '02/24/2026 14:30:00',
    checks: {
      'inlet-pressure': true,
      'tank-pressure-detection': true,
      'system-pressure-detection': true,
      'sensor-data-continuity': true,
      'device-connection-status': true,
      'ro-feed-flow-detection': true,
      'permeate-production-check': true,
      'system-pressure-validation': true,
    },
  },
  {
    id: 2,
    state: 'Failed',
    mode: 'Install',
    triggeredBy: 'Installer name',
    timestamp: '02/24/2026 12:15:00',
    checks: {
      'inlet-pressure': false,
      'tank-pressure-detection': true,
      'system-pressure-detection': true,
      'sensor-data-continuity': false,
      'device-connection-status': true,
      'ro-feed-flow-detection': true,
      'permeate-production-check': true,
      'system-pressure-validation': true,
    },
  },
  ...Array(9)
    .fill(null)
    .map((_, i) => ({
      id: 3 + i,
      state: 'Failed',
      mode: 'Install',
      triggeredBy: 'Installer name',
      timestamp: `02/24/2026 ${10 + i}:00:00`,
      checks: {
        'inlet-pressure': false,
        'tank-pressure-detection': true,
        'system-pressure-detection': true,
        'sensor-data-continuity': false,
        'device-connection-status': true,
        'ro-feed-flow-detection': true,
        'permeate-production-check': true,
        'system-pressure-validation': true,
      },
    })),
];
